import { ALL_OPTION } from '../../shared/constants';
import isEqual from 'lodash/isEqual';

export const compareStringArrayUnordered = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr1)) {
    return false;
  }
  return isEqual([...arr1].sort(), [...arr2].sort());
};

export const compareString = (val1, val2) => val1 === val2;

export const compareBookToTaxDifference = (b1, b2) =>
  compareStringArrayUnordered(b1.countryTaxTypes, b2.countryTaxTypes)
  && compareString(b1.exceptionAccount, b2.exceptionAccount)
  && compareString(b1.exceptionBasis, b2.exceptionBasis);

export const createBookToTaxDifference = () => ({
  connections: [ALL_OPTION],
  businessUnits: [],
  countryTaxTypes: [ALL_OPTION],
  description: '',
  disallowedPercentage: 0,
  enabledFlag: '',
  exceptionAccount: '',
  exceptionBasis: '',
  exceptionId: null,
  excludedCompanyCodes: [],
  tagDescription: '',
});
